import Vue from 'vue';
import VueRouter from 'vue-router';

import HomeView from '../views/HomeView.vue';

// master data
import Role from '@/views/masterData/role.vue';
import TTAccount from '@/views/masterData/tt-account.vue';
import TTBudget from '@/views/masterData/tt-budgetItem.vue';
import opexGL from '@/views/masterData/opex-gl.vue';
import capexGl from '@/views/masterData/capex-gl.vue';
import fundCenter from '@/views/masterData/fund-center';
import fund from '@/views/masterData/fund';
import imNumber from '@/views/masterData/im-file';
import masterBudgetType from '@/views/masterData/masterBudgetType/main.vue';
import projectTag from '@/views/masterData/projectTag/main.vue';

import roleManagement from '@/views/role-management.vue';
import user from '@/views/masterData/user/list.vue';
import userDetail from '@/views/masterData/user/detail.vue';
import userEdit from '@/views/masterData/user/edit.vue';
import userAdd from '@/views/masterData/user/add.vue';

import orgChart from '@/views/masterData/org-chart/list.vue';
import orgChartDetail from '@/views/masterData/org-chart/detail.vue';
import orgChartEdit from '@/views/masterData/org-chart/edit.vue';
import orgChartAdd from '@/views/masterData/org-chart/add.vue';

//
import BudgetPlan from '../views/budgetPlan/main.vue';
import BudgetPlanCreate from '../views/budgetPlan/create.vue';
import BuddgetPlanDetail from '../views/budgetPlan/detail.vue';
import budgetPlanEdit from '../views/budgetPlan/edit.vue';
import budgetPlanCompare from '../views/budgetPlan/compare.vue';
import MonitorBudget from '../views/monitorBudget/main.vue';
import compareBudget from '../views/compare/main.vue';
import historyBudget from '../views/history/main.vue';
import historicalLog from '../views/historicalLog/main.vue';
import BudgetPlanHistories from '../views/budgetPlan/historicalLog.vue';
import Maintenance from '../views/maintenance.vue';
import axiosIns from '@/api/axios';
// import { component } from "vue/types/umd";

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView,
	},
	{
		path: '/master-data/role',
		name: 'role',
		component: Role,
	},
	{
		path: '/master-data/budget-type',
		name: 'md_budget_type',
	},
	{
		path: '/master-data/budget-item',
		name: 'md_budget_item',
	},
	{
		path: '/master-data/im-number',
		name: 'im_number',
		component: imNumber,
	},
	{
		path: '/master-data/master-budget-type',
		name: 'master_budget_type',
		component: masterBudgetType,
	},
	{
		path: '/master-data/project-tags',
		name: 'project_tag',
		component: projectTag,
	},
	{
		path: '/budget-plan',
		name: 'budget_plan',
		component: BudgetPlan,
	},
	{
		path: '/budget-plan/create',
		name: 'budget_plan_create',
		component: BudgetPlanCreate,
	},
	{
		path: '/budget-plan/detail/:id?',
		name: 'budget_plan_detail',
		component: BuddgetPlanDetail,
	},
	{
		path: '/budget-plan/histories/:id?',
		name: 'budget_plan_histories',
		component: BudgetPlanHistories,
	},
	{
		path: '/budget-plan/compare/:id?',
		name: 'budget_plan_compare',
		component: budgetPlanCompare,
	},
	{
		path: '/budget-plan/edit/:id?',
		name: 'budget_plan_edit',
		component: budgetPlanEdit,
	},
	{
		path: '/role-management',
		name: 'role-management',
		component: roleManagement,
	},
	{
		path: '/master-data/tt-account',
		name: 'tt-account',
		component: TTAccount,
	},
	{
		path: '/master-data/tt-budget-item',
		name: 'tt-budgeItem',
		component: TTBudget,
	},
	{
		path: '/master-data/opex-gl',
		name: 'opexGL',
		component: opexGL,
	},
	{
		path: '/master-data/capex-gl',
		name: 'capex',
		component: capexGl,
	},
	{
		path: '/master-data/fund-center',
		name: 'fundCenter',
		component: fundCenter,
	},
	{
		path: '/master-data/fund',
		name: 'fund',
		component: fund,
	},

	{
		path: '/master-data/user',
		name: 'user',
		component: user,
	},
	{
		path: '/master-data/user/add',
		name: 'master_data_user_add',
		component: userAdd,
	},
	{
		path: '/master-data/user/detail/:id?',
		name: 'master_data_user_detail',
		component: userDetail,
	},
	{
		path: '/master-data/user/edit/:id?',
		name: 'master_data_user_edit',
		component: userEdit,
	},

	{
		path: '/master-data/org-chart',
		name: 'org_chart',
		component: orgChart,
	},
	{
		path: '/master-data/org-chart/add',
		name: 'master_data_org_chart_add',
		component: orgChartAdd,
	},
	{
		path: '/master-data/org-chart/detail/:id?',
		name: 'master_data_org_chart_detail',
		component: orgChartDetail,
	},
	{
		path: '/master-data/org-chart/edit/:id?',
		name: 'master_data_org_chart_edit',
		component: orgChartEdit,
	},

	{
		path: '/budget-plan/:id/version/:version_id',
		name: 'budget_plan_detail_version',
	},
	{
		path: '/monitor-budget',
		name: 'monitor_budget',
		component: MonitorBudget,
	},
	{
		path: '/compare-budget',
		name: 'compare_budget',
		component: compareBudget,
	},
	{
		path: '/history-budget',
		name: 'history_budget',
		component: historyBudget,
	},
	{
		path: '/historical-log',
		name: 'historical_log',
		component: historicalLog,
	},
	{
		path: '/maintenance',
		name: 'maintenance',
		component: Maintenance,
	},
];

const isBackendUp = async () => {
	return await axiosIns
		.get(`/health`)
		.then((resp) => {
			return true;
		})
		.catch((err) => {
			return false;
		});
};

const router = new VueRouter({
	mode: 'history',
	routes,
});

router.beforeEach(async (to, from, next) => {
	const isUp = await isBackendUp();
	if (isUp) {
		if (to.name == 'maintenance') {
			next({ name: 'home' });
		} else {
			next();
		}
	} else {
		if (to.name == 'maintenance') {
			next();
		} else {
			next({ name: 'maintenance' });
		}
	}
});

export default router;
